import { Shapes } from "lucide-react";

import { createConfigurationLucideIcon } from "./createNavigationLucideIcon";

export const ConfigurationProductTypesIcon = createConfigurationLucideIcon(Shapes);
